<template>
    <div class="jr-component">
      <div class="jr-selectwhere">
        <span class="jr-display-name">
        {{ components.controlDisplayname }}
      </span>
      <el-select :title="selectLabels" :ref="components.controlId" class="jr-input" @visible-change="change" v-bind="$attrs" :multiple="true" collapse-tags :id="components.controlId" :size="size" v-model="componentValue.controlDefaultvalue" :disabled="!components.controlRighttype || components.controlReadonly" filterable placeholder="请选择">
        <template v-if="selectDataParam !== undefined"><el-option v-for="(item, i) in selectData" :key="i" :label="item[selectDataParam.label]" :value="item[selectDataParam.value]"></el-option></template>
        <template v-if="selectDataParam === undefined"><el-option v-for="(item, i) in selectData" :key="i" :label="item" :value="i"></el-option></template>
      </el-select>  
      <i @click="rightClick" v-if="badge & components.controlRighttype" class="el-icon-success jr-right-ico" style="color: green;"/>
      <i @click="rightClick" v-if="badge & !components.controlRighttype" class="el-icon-error jr-right-ico" style="color: red;"/> 
    </div>
    </div>
</template>
<script>
export default {
  name: 'JrSelectwhere',
  computed: {
    componentValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  data() {
    return {
      selectLabels: ''
    }
  },
  props: {
    value: {},
    badge: {
      type: Boolean,
      default: false
    },
    components: {},
    selectData: {},
    selectDataParam: {},
    size: {
      type: String,
      default: 'small'
    }
    
  },
  methods: {
    rightClick(){
      this.$emit('badge-click', this.components.controlId, !this.components.controlRighttype)
    },
    change(e){
      if(!e){        
        let selectLabels = ''
        for(var key in this.$refs[this.components.controlId].selected){
          selectLabels = selectLabels + this.$refs[this.components.controlId].selected[key].label + ','
        }
        this.selectLabels = selectLabels.substr(0,selectLabels.length-1)
        this.componentValue.controlDefaultlabel = this.selectLabels
      }      
    }
  }
}

</script>
<style scoped lang="scss">
  .jr-display-name{
    width: 120px;
    text-align: right;
    vertical-align: middle;
    padding-right: 10px;
    color: #676767;
    display: inline-block; 

  }
  .jr-input{
    width: 190px;
  }
  .jr-selectwhere{
    display: flex;
    flex-direction: row ;
    justify-content: flex-start;
    align-items: center;
  }
</style>


// WEBPACK FOOTER //
// src/components/componentsjr/JrSelectwhere.vue